var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTierTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3129 14.2975L23.6754 19.2175L25.3642 26.5425C25.4535 26.9254 25.428 27.3262 25.2909 27.6947C25.1537 28.0632 24.9109 28.3831 24.5929 28.6144C24.2749 28.8457 23.8958 28.9782 23.503 28.9951C23.1101 29.0121 22.721 28.913 22.3842 28.71L15.9954 24.835L9.62042 28.71C9.28363 28.913 8.89449 29.0121 8.50164 28.9951C8.10878 28.9782 7.72966 28.8457 7.41166 28.6144C7.09366 28.3831 6.8509 28.0632 6.71373 27.6947C6.57655 27.3262 6.55105 26.9254 6.64042 26.5425L8.32667 19.225L2.68792 14.2975C2.38968 14.0403 2.17402 13.7007 2.06799 13.3214C1.96196 12.9421 1.97027 12.54 2.09188 12.1654C2.2135 11.7908 2.443 11.4604 2.75162 11.2158C3.06023 10.9711 3.43421 10.823 3.82667 10.79L11.2592 10.1462L14.1604 3.22624C14.3119 2.86314 14.5675 2.55298 14.8949 2.33482C15.2223 2.11665 15.607 2.00024 16.0004 2.00024C16.3939 2.00024 16.7785 2.11665 17.1059 2.33482C17.4334 2.55298 17.6889 2.86314 17.8404 3.22624L20.7504 10.1462L28.1804 10.79C28.5729 10.823 28.9469 10.9711 29.2555 11.2158C29.5641 11.4604 29.7936 11.7908 29.9152 12.1654C30.0368 12.54 30.0451 12.9421 29.9391 13.3214C29.8331 13.7007 29.6174 14.0403 29.3192 14.2975H29.3129Z",
    fill: "url(#paint0_linear_8323_51478)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8323_51478",
    x1: 2.2392,
    y1: 2.85457,
    x2: 23.396,
    y2: 12.0116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4D1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierTwo);
export default __webpack_public_path__ + "static/media/tier-two.7dffac3f.svg";
export { ForwardRef as ReactComponent };